// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"82b33fd9","175":"102daefa","688":"c0337fad","932":"e06edf57"}[chunkId] + ".chunk.css";
};